// Receipt truth stays on the alert server. Read/dismiss state is local to this
// browser and owner, independent of the broker-notification database contract.
const key = owner => `erevis:price-alert-presentation:v1:${owner}`
export function readAlertPresentation(owner, id) {
  try { return JSON.parse(localStorage.getItem(key(owner)) || '{}')[id] || {} } catch { return {} }
}
export function persistAlertPresentation(owner, notifications) {
  if (!owner) return
  try {
    const saved = JSON.parse(localStorage.getItem(key(owner)) || '{}')
    for (const n of notifications.filter(n => n.source === 'price-alert' && n.ownerUserId === owner)) {
      saved[n.id] = { read: n.read === true, dismissed: n.dismissed === true, cleared: n.cleared === true, popupDismissed: n.popupDismissed === true }
    }
    localStorage.setItem(key(owner), JSON.stringify(Object.fromEntries(Object.entries(saved).slice(-200))))
  } catch { /* Local presentation persistence is best effort. */ }
}
